export default __webpack_public_path__ + "static/media/warning-triangle.ed6d2961.svg";